import UAParser from 'ua-parser-js'

export default function Settings () {
  const scriptElt = document.querySelector('script[data-gb-service="zenmsg"]:not([data-gb-done])')
  if (scriptElt !== null) {
    const account = scriptElt.getAttribute('data-gb-account')
    const host = scriptElt.getAttribute('data-gb-host')
    const url = `zenmsg/${account}/`
    let options = null // options to handle ZenMsg from the host page
    // available options are:
    //   - instances: a list of CSS selectors for buttons that will allow to
    //       show/hide the widget. Comma separated.
    //       Ex: ".btn.btn-cta" or "#btn-foo,#btn-bar"
    //   - offlineUrl: a URL that will be launched when no agent are available
    if (scriptElt.getAttribute('data-gb-instances')) {
      if (options === null) {
        options = {}
      }
      options.instances = scriptElt.getAttribute('data-gb-instances').split(',')
    }
    if (scriptElt.getAttribute('data-gb-offline-url')) {
      if (options === null) {
        options = {}
      }
      options.offlineUrl = scriptElt.getAttribute('data-gb-offline-url')
    }

    scriptElt.setAttribute('data-gb-done', true)

    scriptElt.insertAdjacentHTML(
      'afterend',
      '<div></div>')

    const elt = scriptElt.nextSibling

    let caller = ''
    if (window.location.href.indexOf('gb-caller=') > -1) {
      caller = window.location.href.substring(
        window.location.href.indexOf('gb-caller=') + 10,
        window.location.href.indexOf('gb-caller=') + 20)
    }

    const ua = () => {
      const MOBILE_DEVICES = ['mobile', 'tablet', 'wearable', 'embedded']
      const parser = new UAParser()
      const res = parser.getResult()
      const model = res.device.model || 'PC'
      const isMobile = MOBILE_DEVICES.indexOf(res.device.type) > -1

      return {
        browser: res.browser.name,
        model: model,
        device: `${model}/${res.os.name}`,
        language: window.navigator.language,
        isMobile: isMobile
      }
    }

    return {
      account: account,
      caller: caller,
      elt: elt,
      host: host,
      options: options,
      ua: ua(),
      url: url
    }
  }

  return null
}
